/**
 * Every off-site URL this app links to, in one place.
 *
 * The legal slugs are the published ones on bonded.studio — not every path that
 * reads like a legal page exists, so do not invent new ones here. These two are
 * the pair the survey has always linked, now shared with the marketing landing
 * page so a slug change is a one-line edit rather than a hunt.
 */
export const TERMS_URL = 'https://bonded.studio/terms-of-service/'
export const PRIVACY_URL = 'https://bonded.studio/privacy-policy/'

/**
 * The app's marketing page, deliberately not the App Store listing.
 *
 * Bonded is iPhone-only and launching in a few countries first, so a direct
 * store link dead-ends for an Android visitor and for anyone outside the launch
 * markets. /app tells the whole story and captures the rest on the newsletter.
 */
export const APP_PAGE_URL = 'https://bonded.studio/app'
